export default {
	name: "NotifiableMixin",

	data: () => ( {
		appId: process.env.NODE_ENV === "development"
			? "ff7dd2cd-a715-4b17-9ac9-b725fec1daa4"
			: "37c90931-5622-4984-92ad-db25f26dbba5",
		oneSignal: window.OneSignal || [],
		notification: null
	} ),

	computed: {
		isAuthenticated() {
			return this.$store.getters["auth/isAuthenticated"];
		},

		isNavigatable() {
			return this.isAuthenticated
				&& this.notification
				&& this.notification.data
				&& this.notification.data.route;
		}
	},

	watch: {
		isNavigatable( isNavigatable ) {
			if ( isNavigatable ) {
				this.$router.push( { name: this.notification.data.route } );
			}
		}
	},

	methods: {
		init() {
			this.oneSignal.push( [ "init", {
				appId: this.appId
			} ] );

			this.oneSignal.push( [ "isPushNotificationsEnabled", isEnabled => {
				if ( !isEnabled ) {
					this.oneSignal.showHttpPrompt();
				}
			} ] );
		},

		listenForNotifications() {
			this.oneSignal.push( [ "addListenerForNotificationOpened", notification => {
				this.notification = notification;
				this.listenForNotifications();
			} ] );
		},

		addListeners() {
			this.oneSignal.push( () => {
				this.oneSignal.on( "subscriptionChange", isSubscribed => {
					if ( isSubscribed ) {
						this.$store.dispatch( "oneSignal/updateIdDevice", idDevice =>
							this.$http.post( "users/devices", { idDevice } )
						);
					}
				} );
			} );
		}
	},

	created() {
		const unwatch = this.$watch( "isAuthenticated", isAuthenticated => {
			if ( isAuthenticated ) {
				this.init();
				this.listenForNotifications();
				this.addListeners();

				unwatch();
			}
		}, { immediate: true } );
	}
};
